// src/redux/reducers/riskReducer.js

import {
  INITIALIZE_ASSESSMENT,
  FETCH_ASSESSMENTS_START,
  FETCH_ASSESSMENTS_SUCCESS,
  FETCH_ASSESSMENTS_FAILURE,
  FETCH_ASSESSMENT_RISKS_SUCCESS,
  DELETE_ASSESSMENT,
  // SET_SECTION, // LEGACY - action creator exists but never imported/called from components
  SET_ASSESSMENT_POSITION,
  SET_STEP,
  UPDATE_ASSESSMENT_STEP_SUCCESS,
  UPDATE_ASSESSMENT_STEP_FAILURE,
  SET_MODEL_ID,
  // SET_CURRENT_ASSESSMENT, // LEGACY - components use RTK appSlice.setCurrentAssessment instead
  DISCARD_RISKS,
  DISCARD_UNSAVED_RISKS,
  REFINE_RISK_START,
  REFINE_RISK_SUCCESS,
  REFINE_RISK_FAILURE,
  UPDATE_RISK_NAME,
  FETCH_RISKS_START, 
  FETCH_RISKS_FAILURE, 
  SET_RISK_EVALUATION,
  UPDATE_RISK_PRIORITY,
  UPDATE_RISK_EVALUATION,
  // UPDATE_CONTROL_IN_SELECTED_RISK, // LEGACY - action creator exists but never imported/called from components
  FETCH_RISK_CARD_DATA_START, 
  FETCH_RISK_CARD_DATA_SUCCESS, 
  FETCH_RISK_CARD_DATA_FAILURE, 
  FETCH_RISK_EVALUATIONS, 
  FETCH_RISK_EVALUATIONS_SUCCESS,
  FETCH_RISK_EVALUATIONS_FAILURE,
  UPDATE_ACTIVE_SECTIONS_FROM_SAVED_RISKS,
  MOVE_RISK_TO_SAVED,
  UPDATE_SAVED_RISK,
  DISCARD_SAVED_RISK,
  RESET_RISKS_STATE,
  FETCH_SECTION_SPECIFIC_RISKS_START,
  FETCH_SECTION_SPECIFIC_RISKS_SUCCESS,
  FETCH_SECTION_SPECIFIC_RISKS_FAILURE,
  ASSESSMENT_STATUS_UPDATED,
  ASSESSMENT_STATUS_FAILED,
  REFRESH_RISKS_SUCCESS,
  SET_RISK_PRIORITY_START,
  SET_RISK_PRIORITY_SUCCESS,
  SET_RISK_PRIORITY_FAILURE,
  UPDATE_LOADING_MESSAGE,
  UPDATE_SECTION_PROGRESS,
  //UPDATE_CAUSE_FIELD,
  SAVE_RISK_SOURCE_START,
  SAVE_RISK_SOURCE_SUCCESS,
  SAVE_RISK_SOURCE_FAILURE,
  SAVE_CAUSES_START,
  SAVE_CAUSES_SUCCESS,
  SAVE_CAUSES_FAILURE,
  // INITIALIZE_DRAFT_RISKS, // Legacy - removed
  SET_CURRENT_SECTION,
  SET_CURRENT_SECTION_STEP,
  RESET_CURRENT_SECTION_STEP,
  CONFIG_UPDATE_SUCCESS, 
  CONFIG_UPDATE_FAILURE,
  ADD_MANUAL_RISK,
  SET_RISK_SOURCE,
  SET_ROOT_CAUSE,
  SET_DEEP_DIVE_DETAIL,
  SET_DEEP_DIVE_VALUES,
  GENERATE_RISK_NARRATIVE_START,
  GENERATE_RISK_NARRATIVE_SUCCESS,
  GENERATE_RISK_NARRATIVE_FAILURE,
  SELECT_RISK_SOURCE,
  DESELECT_RISK_SOURCE,
   MOVE_SCENARIO_TO_RISKS,
   REGISTER_RISK_SOURCES,
  TOGGLE_RISK_SOURCE,
  SET_RISK_SOURCE_PROGRESS,
  // New area-based actions
  SET_AREA_STATUS,
  SET_AREA_DEFERRED,
  SET_AREA_NOT_APPLICABLE,
  CLEAR_AREA_STATUS
} from '../actions/actionTypes.js';
   
import { mergeRiskSources, mergeRiskRootCauses, mergeRiskCauseEvaluation } from '../reduxutils/riskFormUtils.js';
import { v4 as uuidv4 } from 'uuid';
// Removed evaluationForm import - now using state.configs.riskEvaluationForm
import _ from 'lodash';

  


const initialState = {
  byAssessment: {},              // Keyed by assessmentUuid (was: models keyed by modelId)
  loading: false,                // Was: modelsLoading
  loadingMessage: '',
  currentModelId: null,          // Track the currently active model (for model-specific operations)
  currentAssessmentUuid: null    // Track the currently active assessment (PRIMARY KEY)
};


/**
 * Initialize an assessment entry in state.risks.byAssessment
 * Now keyed by assessmentUuid instead of modelId
 */
const initializeAssessment = (assessmentUuid, modelId, modelName, modelType, modelStage, useCaseShortDescription, created_at, created_by, avatar, createdByName, assessmentStatus, currentStep, modelRisks, templateId, mode, autonomous, position, ownerName, ownerEmail, lastUpdatedByName, lastUpdatedByEmail, reviewStatus, updatedAt, state) => {
  if (assessmentUuid && !state.byAssessment[assessmentUuid]) {
    // Use evaluation form from configs state if available, fallback to empty array
    const evaluationCriteria = state.config?.configs?.riskEvaluationForm || [];

    return {
      ...state,
      byAssessment: {
        ...state.byAssessment,
        [assessmentUuid]: {
          // Model info (optional - null for Explorer assessments without model)
          modelId: modelId || null,
          modelName,
          modelType,
          modelStage,
          useCaseShortDescription,
          created_at,
          created_by,
          avatar,
          createdByName,
          // Assessment metadata
          assessmentStatus,
          template_id: templateId || null,
          mode: mode || null,
          autonomous: autonomous || null,
          position: position || null,
          owner_name: ownerName || null,
          owner_email: ownerEmail || null,
          last_updated_by_name: lastUpdatedByName || null,
          last_updated_by_email: lastUpdatedByEmail || null,
          review_status: reviewStatus || null,
          updated_at: updatedAt || null,
          // Risk data container (renamed from riskFormData)
          modelRisks,
          // UI state
          activeSections: [],
          sectionLoading: {},
          selectedRisks: [],
          risks: [],
          selectedThemes: [],
          discardedRisks: [],
          savedRisks: state.byAssessment[assessmentUuid]?.savedRisks?.map(risk => ({
            ...risk,
            evaluationData: risk.evaluationData || evaluationCriteria,
            selectedControls: risk.selectedControls || []
          })) || [],
          loading: false,
          error: null,
          step: currentStep || 'Not Started'
        },
      },
    };
  }
  return state;
}

const riskReducer = (state = initialState, action) => {
  switch (action.type) {

    case RESET_RISKS_STATE:
      return initialState;

    case FETCH_ASSESSMENTS_START:
      return {
        ...state,
        loading: true,
        loadingMessage: 'Fetching assessments...'
      };

    


    case FETCH_ASSESSMENTS_SUCCESS: {
      const { assessments } = action.payload;

      let newState = { ...state, loading: false, loadingMessage: '' };
      assessments.forEach(assessment => {
        if (!newState.byAssessment[assessment.assessment_uuid]) {
          newState = initializeAssessment(
            assessment.assessment_uuid,        // assessmentUuid (PRIMARY KEY)
            assessment.model_uuid,             // modelId (optional reference)
            assessment.model_name,
            assessment.model_type,
            assessment.model_stage,
            assessment.use_case_short_description,
            assessment.created_at,
            assessment.created_by,
            assessment.avatar,
            assessment.name,
            assessment.assessment_status,
            assessment.current_step || 'Not Started',
            action.payload.modelRisks,         // renamed from riskFormData
            assessment.template_id || null,
            assessment.mode || null,
            assessment.autonomous || null,
            assessment.position || null,
            assessment.owner_name || null,
            assessment.owner_email || null,
            assessment.last_updated_by_name || null,
            assessment.last_updated_by_email || null,
            assessment.review_status || null,
            assessment.updated_at || null,
            newState
          );
        }
      });

      return newState;
    }

    case FETCH_ASSESSMENTS_FAILURE:
      return {
        ...state,
        loading: false,
        loadingMessage: 'Failed to load data.'
      };

    case INITIALIZE_ASSESSMENT: {
      const {
        assessmentUuid, modelId, modelName, modelType, modelStage, useCaseShortDescription,
        created_at, created_by, avatar, createdByName,
        assessmentStatus, currentStep, modelRisks, templateId,
        mode, autonomous, position, ownerName, ownerEmail,
        lastUpdatedByName, lastUpdatedByEmail, reviewStatus, updatedAt
      } = action.payload;
      return initializeAssessment(
        assessmentUuid, modelId, modelName, modelType, modelStage, useCaseShortDescription,
        created_at, created_by, avatar, createdByName,
        assessmentStatus, currentStep, modelRisks, templateId,
        mode, autonomous, position, ownerName, ownerEmail,
        lastUpdatedByName, lastUpdatedByEmail, reviewStatus, updatedAt,
        state
      );
    }

    case DELETE_ASSESSMENT: {
      const assessmentUuid = action.payload;
      const newByAssessment = { ...state.byAssessment };
      delete newByAssessment[assessmentUuid];
      return {
        ...state,
        byAssessment: newByAssessment,
      };
    }

    

    // SET_MODEL_ID is kept for backward compatibility but now operates on assessmentUuid
    case SET_MODEL_ID: {
      const {
        assessmentUuid,
        modelId,
        modelName,
        modelType,
        modelStage,
        useCaseShortDescription,
        created_at,
        created_by,
        avatar,
        createdByName,
        assessmentStatus,
        currentStep,
        modelRisks,
        templateId,
        mode,
        autonomous,
        position,
        ownerName,
        ownerEmail,
        lastUpdatedByName,
        lastUpdatedByEmail,
        reviewStatus,
        updatedAt
      } = action.payload;

      console.log('SET_MODEL_ID action payload:', action.payload);

      let newState = { ...state };

      if (assessmentUuid) {
        if (!newState.byAssessment[assessmentUuid]) {
          // Assessment doesn't exist yet, initialize it
          newState = initializeAssessment(
            assessmentUuid,
            modelId,
            modelName,
            modelType,
            modelStage,
            useCaseShortDescription,
            created_at,
            created_by,
            avatar,
            createdByName,
            assessmentStatus,
            currentStep,
            modelRisks,
            templateId,
            mode || null,
            autonomous || null,
            position || null,
            ownerName || null,
            ownerEmail || null,
            lastUpdatedByName || null,
            lastUpdatedByEmail || null,
            reviewStatus || null,
            updatedAt || null,
            newState
          );
        } else {
          // Assessment exists, just update the fields
          const existingAssessment = newState.byAssessment[assessmentUuid];
          newState.byAssessment[assessmentUuid] = {
            ...existingAssessment,
            modelId: modelId || existingAssessment.modelId,
            modelName: modelName || existingAssessment.modelName,
            modelType: modelType || existingAssessment.modelType,
            modelStage: modelStage || existingAssessment.modelStage,
            useCaseShortDescription: useCaseShortDescription || existingAssessment.useCaseShortDescription,
            created_at: created_at || existingAssessment.created_at,
            created_by: created_by || existingAssessment.created_by,
            avatar: avatar || existingAssessment.avatar,
            createdByName: createdByName || existingAssessment.createdByName,
            assessmentStatus: assessmentStatus || existingAssessment.assessmentStatus,
            template_id: templateId !== undefined ? templateId : existingAssessment.template_id,
            mode: mode !== undefined ? mode : existingAssessment.mode,
            autonomous: autonomous !== undefined ? autonomous : existingAssessment.autonomous,
            position: position !== undefined ? position : (currentStep
              ? { ...existingAssessment.position, majorStep: currentStep }
              : existingAssessment.position || { majorStep: existingAssessment.step || 'useCase' }),
            owner_name: ownerName !== undefined ? ownerName : existingAssessment.owner_name,
            owner_email: ownerEmail !== undefined ? ownerEmail : existingAssessment.owner_email,
            last_updated_by_name: lastUpdatedByName !== undefined ? lastUpdatedByName : existingAssessment.last_updated_by_name,
            last_updated_by_email: lastUpdatedByEmail !== undefined ? lastUpdatedByEmail : existingAssessment.last_updated_by_email,
            review_status: reviewStatus !== undefined ? reviewStatus : existingAssessment.review_status,
            updated_at: updatedAt !== undefined ? updatedAt : existingAssessment.updated_at,
            step: currentStep || existingAssessment.step,
          };
        }
      }

      return newState;
    }

    // LEGACY - components use RTK appSlice.setCurrentAssessment instead
    // case SET_CURRENT_ASSESSMENT: {
    //   const { modelId, assessmentUuid, templateId, templateConfig } = action.payload;
    //
    //   // Build updated state
    //   const updatedState = {
    //     ...state,
    //     currentModelId: modelId,
    //     currentAssessmentUuid: assessmentUuid
    //   };
    //
    //   // If templateId or templateConfig is provided and assessment exists, update it
    //   if (assessmentUuid && updatedState.byAssessment[assessmentUuid]) {
    //     const assessmentUpdates = {};
    //
    //     if (templateId !== undefined) {
    //       assessmentUpdates.template_id = templateId;
    //     }
    //
    //     if (templateConfig !== null) {
    //       assessmentUpdates.templateConfig = templateConfig;
    //     }
    //
    //     if (Object.keys(assessmentUpdates).length > 0) {
    //       updatedState.byAssessment = {
    //         ...updatedState.byAssessment,
    //         [assessmentUuid]: {
    //           ...updatedState.byAssessment[assessmentUuid],
    //           ...assessmentUpdates
    //         }
    //       };
    //     }
    //   }
    //
    //   return updatedState;
    // }

    case UPDATE_LOADING_MESSAGE:
      return {
        ...state,
        loadingMessage: action.payload
      };

    // LEGACY - SET_SECTION action creator exists but never imported/called from components
    // case SET_SECTION: {
    //   const { assessmentUuid, sectionName } = action.payload;
    //   const assessment = state.byAssessment[assessmentUuid];
    //
    //   if (!assessment) {
    //     console.error(`Assessment with ID ${assessmentUuid} not found.`);
    //     return state;
    //   }
    //
    //   const section = assessment.activeSections[sectionName];
    //   if (!section) {
    //     console.error(`Section ${sectionName} not found in assessment ${assessmentUuid}.`);
    //     return state;
    //   }
    //
    //   return {
    //     ...state,
    //     byAssessment: {
    //       ...state.byAssessment,
    //       [assessmentUuid]: {
    //         ...assessment,
    //         currentSection: sectionName,
    //         activeSections: {
    //           ...assessment.activeSections,
    //           [sectionName]: {
    //             ...section
    //           }
    //         }
    //       }
    //     }
    //   };
    // }


    // ────────────────────────────────────────────────────────
    // New area-based status management cases
    // ────────────────────────────────────────────────────────
    
    case SET_AREA_STATUS: {
      const { assessmentUuid, areaName, status } = action.payload;
      const assessment = state.byAssessment[assessmentUuid];
      if (!assessment) return state;

      // Guard against undefined modelRisks (RTK-first mode)
      const modelRisks = assessment.modelRisks || {};
      const current = modelRisks[areaName] || {};

      return {
        ...state,
        byAssessment: {
          ...state.byAssessment,
          [assessmentUuid]: {
            ...assessment,
            modelRisks: {
              ...modelRisks,
              [areaName]: {
                ...current,
                status,
                assessmentProgress: status === 'NA' || status === 'DEFERRED' ? 100 : current.assessmentProgress || 0
              }
            }
          }
        }
      };
    }

    case SET_AREA_DEFERRED: {
      const { assessmentUuid, areaName } = action.payload;
      const assessment = state.byAssessment[assessmentUuid];
      if (!assessment) return state;

      // Guard against undefined modelRisks (RTK-first mode)
      const modelRisks = assessment.modelRisks || {};
      const current = modelRisks[areaName] || {};

      return {
        ...state,
        byAssessment: {
          ...state.byAssessment,
          [assessmentUuid]: {
            ...assessment,
            modelRisks: {
              ...modelRisks,
              [areaName]: {
                ...current,
                status: 'DEFERRED',
                assessmentProgress: 100, // Mark as complete for progress tracking
                deferredAt: new Date().toISOString()
              }
            }
          }
        }
      };
    }

    case SET_AREA_NOT_APPLICABLE: {
      const { assessmentUuid, areaName } = action.payload;
      const assessment = state.byAssessment[assessmentUuid];
      if (!assessment) return state;

      // Guard against undefined modelRisks (RTK-first mode)
      const modelRisks = assessment.modelRisks || {};
      const current = modelRisks[areaName] || {};

      return {
        ...state,
        byAssessment: {
          ...state.byAssessment,
          [assessmentUuid]: {
            ...assessment,
            modelRisks: {
              ...modelRisks,
              [areaName]: {
                ...current,
                status: 'NA',
                assessmentProgress: 100, // Mark as complete for progress tracking
                markedNAAt: new Date().toISOString()
              }
            }
          }
        }
      };
    }

    case CLEAR_AREA_STATUS: {
      const { assessmentUuid, areaName } = action.payload;
      const assessment = state.byAssessment[assessmentUuid];
      if (!assessment) return state;

      // Guard against undefined modelRisks (RTK-first mode)
      const modelRisks = assessment.modelRisks || {};
      const current = modelRisks[areaName] || {};

      // Remove status and timestamps, reset progress if no actual progress made
      const { status, deferredAt, markedNAAt, ...cleanedArea } = current;

      return {
        ...state,
        byAssessment: {
          ...state.byAssessment,
          [assessmentUuid]: {
            ...assessment,
            modelRisks: {
              ...modelRisks,
              [areaName]: {
                ...cleanedArea,
                assessmentProgress: 0 // Reset progress when re-enabling
              }
            }
          }
        }
      };
    }

    /* ───────────────────────────────────────────────────── */
    /*  Single‑risk flow                                     */
    case SELECT_RISK_SOURCE: {
      const { assessmentUuid, riskArea, src } = action.payload;
      const assessment = state.byAssessment[assessmentUuid];
      if (!assessment) return state;

      // Guard against undefined modelRisks (can happen in RTK-first mode)
      const modelRisks = assessment.modelRisks || {};
      const area = modelRisks[riskArea] || {};

      // --- update selectedSources ---
      const already = (area.selectedSources || []).some(s => s.name === src.name);
      const nextSelected = already
        ? area.selectedSources
        : [ ...(area.selectedSources || []), src ];

      // Legacy draft risk auto-creation removed - sources no longer create automatic draft risks

      return {
        ...state,
        byAssessment: {
          ...state.byAssessment,
          [assessmentUuid]: {
            ...assessment,
            modelRisks: {
              ...modelRisks,
              [riskArea]: {
                ...area,
                selectedSources: nextSelected
                // sectionRisks no longer auto-populated - only scenarios create risks
              }
            }
          }
        }
      };
    }

    case DESELECT_RISK_SOURCE: {
      const { assessmentUuid, riskArea, srcName } = action.payload;
      const assessment = state.byAssessment[assessmentUuid];
      if (!assessment) return state;

      // Guard against undefined modelRisks (can happen in RTK-first mode)
      const modelRisks = assessment.modelRisks || {};
      const area = modelRisks[riskArea] || {};
      const nextSelected = (area.selectedSources || []).filter(s => s.name !== srcName);

      return {
        ...state,
        byAssessment: {
          ...state.byAssessment,
          [assessmentUuid]: {
            ...assessment,
            modelRisks: {
              ...modelRisks,
              [riskArea]: {
                ...area,
                selectedSources: nextSelected
              }
            }
          }
        }
      };
    }

    /* ───────────────────────────────────────────────────── */
    case SET_ASSESSMENT_POSITION: {
      const { assessmentUuid, position } = action.payload;
      if (!state.byAssessment[assessmentUuid]) return state;
      return {
        ...state,
        byAssessment: {
          ...state.byAssessment,
          [assessmentUuid]: {
            ...state.byAssessment[assessmentUuid],
            position
          }
        }
      };
    }

  case CONFIG_UPDATE_SUCCESS: {
    const { name, data } = action.payload;
    console.log(`CONFIG_UPDATE_SUCCESS received for config: ${name}`);

    // Define which configurations affect this reducer
    const relevantConfigs = ['riskSources', 'riskRootCauses', 'riskCauseEvaluation'];
    if (!relevantConfigs.includes(name)) {
      // If the updated config doesn't affect this reducer, do nothing
      return state;
    }

    // Determine which utility function to use based on the configName
    let updatedByAssessment = _.cloneDeep(state.byAssessment);
    Object.keys(updatedByAssessment).forEach(assessmentUuid => {
      const existingModelRisks = updatedByAssessment[assessmentUuid].modelRisks;
      if (name === 'riskSources') {
        updatedByAssessment[assessmentUuid].modelRisks = mergeRiskSources(existingModelRisks, data);
      } else if (name === 'riskRootCauses') {
        updatedByAssessment[assessmentUuid].modelRisks = mergeRiskRootCauses(existingModelRisks, data);
      } else if (name === 'riskCauseEvaluation') {
        updatedByAssessment[assessmentUuid].modelRisks = mergeRiskCauseEvaluation(existingModelRisks, data);
      }
    });
    return {
      ...state,
      byAssessment: updatedByAssessment,
    };
  }

    // **Configuration Update Failure**
    case CONFIG_UPDATE_FAILURE: {
      return {
        ...state,
        error: action.payload.error
      };
    }

    case SET_RISK_SOURCE: {
      const { assessmentUuid, section, source, values } = action.payload;
      const assessment = state.byAssessment[assessmentUuid];
      if (!assessment) return state;
      const sec = assessment.modelRisks?.[section];
      if (!sec) return state;
      const updated = sec.riskSources.map(s =>
        s.name === source ? { ...s, value: values } : s
      );
      return {
        ...state,
        byAssessment: {
          ...state.byAssessment,
          [assessmentUuid]: {
            ...assessment,
            modelRisks: {
              ...assessment.modelRisks,
              [section]: { ...sec, riskSources: updated }
            }
          }
        }
      };
    }

case SET_ROOT_CAUSE: {
  console.log('🔍 [reducer SET_ROOT_CAUSE] payload:', action.payload);
  console.groupCollapsed('[reducer SET_FIELD]');
  console.log('action.payload:', action.payload);
  const { assessmentUuid, section, source, valueKey, path, newValue } = action.payload;
  console.log('pre-update state.modelRisks[section]:', state.byAssessment[assessmentUuid]?.modelRisks?.[section]);
  console.groupEnd();
  // Guard
  const assessment = state.byAssessment[assessmentUuid];
  if (!assessment) return state;
  const sectionData = assessment.modelRisks?.[section];
  if (!sectionData || !Array.isArray(sectionData.riskSources)) return state;

  // Clone the model slice we need
  const updatedRiskSources = sectionData.riskSources.map(src => {
    if (src.name !== source) return src; // only update the matching source

    // Deep-clone that source to ensure complete isolation
    const clone = _.cloneDeep(src);
    
    // Ensure the source has its own unique causesTemplate if missing
    if (!clone.causesTemplate) {
      clone.causesTemplate = _.cloneDeep(clone.causes || {});
    }
    
    // Decide the target blob:
    //  • When valueKey === null/undefined we write directly into root causes
    //  • otherwise keep the legacy per‑value bucket
    let targetBlob;
    if (valueKey == null) {
      // Ensure causes exists and is isolated from template
      if (!clone.causes) {
        clone.causes = _.cloneDeep(clone.causesTemplate);
      }
      targetBlob = clone.causes;
    } else {
      clone.causesByValue = clone.causesByValue || {};
      if (!clone.causesByValue[valueKey]) {
        // Create a completely isolated copy for this specific value
        clone.causesByValue[valueKey] = _.cloneDeep(clone.causesTemplate);
      }
      targetBlob = clone.causesByValue[valueKey];
    }

    // Traverse into the blob following `path`, then set the new value
    let node = targetBlob;
    for (let i = 0; i < path.length - 1; i++) {
      if (!node[path[i]]) node[path[i]] = {};
      node = node[path[i]];
    }
    {
      const lastKey = path[path.length - 1];
      const existing = node[lastKey];
      node[lastKey] = (existing && typeof existing === 'object')
        ? { ...existing, value: newValue }
        : { value: newValue };
    }

    return clone;
  });

  // Reassemble the section and model
  const updatedSection = {
    ...sectionData,
    riskSources: updatedRiskSources
  };

  return {
    ...state,
    byAssessment: {
      ...state.byAssessment,
      [assessmentUuid]: {
        ...assessment,
        modelRisks: {
          ...assessment.modelRisks,
          [section]: updatedSection
        }
      }
    }
  };
}

// in riskReducer.js, alongside SET_ROOT_CAUSE

case SET_DEEP_DIVE_VALUES: {
  console.log('🔍 [reducer SET_DEEP_DIVE_VALUES] payload:', action.payload);
  const { assessmentUuid, section, source, valueKey, causeCategory, deepValues } = action.payload;
  const assessment = state.byAssessment[assessmentUuid];
  if (!assessment || !assessment.modelRisks) return state;

  const sec = assessment.modelRisks[section];
  if (!sec) return state;

  const updatedSources = sec.riskSources.map(src => {
    if (src.name !== source) return src;
    const clone = _.cloneDeep(src);
    
    // Ensure the source has its own unique causesTemplate
    if (!clone.causesTemplate) {
      clone.causesTemplate = _.cloneDeep(clone.causes || {});
    }
    
    if (valueKey == null) {
      // Ensure causes exists and is isolated from template
      if (!clone.causes) {
        clone.causes = _.cloneDeep(clone.causesTemplate);
      }
      if (!clone.causes[causeCategory]) {
        clone.causes[causeCategory] = {};
      }
      clone.causes[causeCategory].deepValues = deepValues;
    } else {
      clone.causesByValue = clone.causesByValue || {};
      if (!clone.causesByValue[valueKey]) {
        clone.causesByValue[valueKey] = _.cloneDeep(clone.causesTemplate);
      }
      if (!clone.causesByValue[valueKey][causeCategory]) {
        clone.causesByValue[valueKey][causeCategory] = {};
      }
      clone.causesByValue[valueKey][causeCategory].deepValues = deepValues;
    }
    return clone;
  });

  return {
    ...state,
    byAssessment: {
      ...state.byAssessment,
      [assessmentUuid]: {
        ...assessment,
        modelRisks: {
          ...assessment.modelRisks,
          [section]: { ...sec, riskSources: updatedSources }
        }
      }
    }
  };
}

case SET_DEEP_DIVE_DETAIL: {
  console.log('🔍 [reducer SET_DEEP_DIVE_DETAIL] payload:', action.payload);
  const { assessmentUuid, section, source, valueKey, causeCategory, option, detail } = action.payload;
  const assessment = state.byAssessment[assessmentUuid];
  if (!assessment || !assessment.modelRisks) return state;

  const sec = assessment.modelRisks[section];
  if (!sec) return state;

  const updatedSources = sec.riskSources.map(src => {
    if (src.name !== source) return src;
    const clone = _.cloneDeep(src);
    
    // Ensure the source has its own unique causesTemplate
    if (!clone.causesTemplate) {
      clone.causesTemplate = _.cloneDeep(clone.causes || {});
    }
    
    let bucket;
    if (valueKey == null) {
      // Ensure causes exists and is isolated from template
      if (!clone.causes) {
        clone.causes = _.cloneDeep(clone.causesTemplate);
      }
      if (!clone.causes[causeCategory]) {
        clone.causes[causeCategory] = {};
      }
      bucket = clone.causes[causeCategory];
    } else {
      clone.causesByValue = clone.causesByValue || {};
      if (!clone.causesByValue[valueKey]) {
        clone.causesByValue[valueKey] = _.cloneDeep(clone.causesTemplate);
      }
      if (!clone.causesByValue[valueKey][causeCategory]) {
        clone.causesByValue[valueKey][causeCategory] = {};
      }
      bucket = clone.causesByValue[valueKey][causeCategory];
    }
    bucket.deepDetails = bucket.deepDetails || {};
    bucket.deepDetails[option] = detail;
    return clone;
  });

  return {
    ...state,
    byAssessment: {
      ...state.byAssessment,
      [assessmentUuid]: {
        ...assessment,
        modelRisks: {
          ...assessment.modelRisks,
          [section]: { ...sec, riskSources: updatedSources }
        }
      }
    }
  };
}



    case SAVE_RISK_SOURCE_START:
      return {
        ...state,
        savingRiskSource: true,
        saveRiskSourceError: null,
      };
    case SAVE_RISK_SOURCE_SUCCESS:
      return {
        ...state,
        savingRiskSource: false,
        // Optionally, handle success messages or state updates
      };
    case SAVE_RISK_SOURCE_FAILURE:
      return {
        ...state,
        savingRiskSource: false,
        saveRiskSourceError: action.payload,
      };
    case SAVE_CAUSES_START:
      return {
        ...state,
        savingCauses: true,
        saveCausesError: null,
      };
    case SAVE_CAUSES_SUCCESS:
      return {
        ...state,
        savingCauses: false,
        // Optionally, handle success messages or state updates
      };
    case SAVE_CAUSES_FAILURE:
      return {
        ...state,
        savingCauses: false,
        saveCausesError: action.payload,
      };

      // Legacy INITIALIZE_DRAFT_RISKS case removed - sources no longer auto-convert to draft risks

      case SET_CURRENT_SECTION: {
        const { assessmentUuid, sectionName } = action.payload;
        const assessment = state.byAssessment[assessmentUuid];
        if (!assessment) {
          console.error(`Assessment with ID ${assessmentUuid} not found.`);
          return state;
        }
        return {
          ...state,
          byAssessment: {
            ...state.byAssessment,
            [assessmentUuid]: {
              ...assessment,
              currentSection: sectionName,
              currentSectionStep: 'riskIdentification', // Reset to initial step
            },
          },
        };
      }
  
      case SET_CURRENT_SECTION_STEP: {
        const { assessmentUuid, stepName } = action.payload;
        const assessment = state.byAssessment[assessmentUuid];
        if (!assessment) {
          console.error(`Assessment with ID ${assessmentUuid} not found.`);
          return state;
        }
        return {
          ...state,
          byAssessment: {
            ...state.byAssessment,
            [assessmentUuid]: {
              ...assessment,
              currentSectionStep: stepName,
            },
          },
        };
      }
  
      case RESET_CURRENT_SECTION_STEP: {
        const { assessmentUuid } = action.payload;
        const assessment = state.byAssessment[assessmentUuid];
        if (!assessment) {
          console.error(`Assessment with ID ${assessmentUuid} not found.`);
          return state;
        }
        return {
          ...state,
          byAssessment: {
            ...state.byAssessment,
            [assessmentUuid]: {
              ...assessment,
              currentSectionStep: 'riskIdentification', // Reset to initial step
            },
          },
        };
      }

      case ADD_MANUAL_RISK: {
        const { assessmentUuid, sectionName, category, riskName } = action.payload;
        const assessment = state.byAssessment[assessmentUuid];
        if (!assessment) return state;
        // Guard against undefined modelRisks (RTK-first mode)
        const modelRisks = assessment.modelRisks || {};
        const section = modelRisks[sectionName] || {};
        const currentSectionRisks = section.areaRisks || {};
        const categoryRisks = currentSectionRisks[category] || [];
        const newRisk = {
          riskId: uuidv4(),
          riskName,
          category,
          status: 'Draft',
          type: 'Manual',
          owner: null
        };
        return {
          ...state,
          byAssessment: {
            ...state.byAssessment,
            [assessmentUuid]: {
              ...assessment,
              modelRisks: {
                ...modelRisks,
                [sectionName]: {
                  ...section,
                  areaRisks: {
                    ...currentSectionRisks,
                    [category]: [...categoryRisks, newRisk]
                  }
                }
              }
            }
          }
        };
      }
  
  
  

    case FETCH_ASSESSMENT_RISKS_SUCCESS: {
      const { assessmentUuid, risks } = action.payload;

      console.log('Risks fetched from DB for assessmentUuid:', { risks, assessmentUuid });

      const risksBySection = risks.reduce((acc, risk) => {
        const section = risk.active_section
        const category = risk.category || 'Uncategorized'; // Default to 'Uncategorized' if no category

        if (!acc[section]) {
          acc[section] = { areaRisks: {} };
          console.log(`Initialized section: ${section}`);
        }

        if (!acc[section].areaRisks[category]) {
          acc[section].areaRisks[category] = [];
          console.log(`Initialized category: ${category} under section: ${section}`);
        }

        const owner = {
          name: risk.owner_name || 'Unknown',
          email: risk.owner_email || 'Unknown',
          picture: risk.owner_picture || 'https://via.placeholder.com/150', // Default avatar
        };

        const newRisk = {
          riskId: risk.risk_id,
          riskName: risk.risk_name,
          category: risk.category,
          priority: risk.priority,
          rationale: risk.rationale,
          status: 'Saved',
          owner: owner,
          type: risk.risk_type || 'Unknown',
          rag_source_file:risk.rag_source_file,
          loading:false
        };

        // Assign risk_source only if type is 'RAG'
        if (risk.risk_type === 'RAG') {
          newRisk.rag_source_file = risk.rag_source_file || 'Unknown';
        
        };

        // Assign type
        newRisk.type = risk.risk_type || 'Unknown';

        acc[section].areaRisks[category].push(newRisk);

        return acc;
      }, {});


      console.log('Final risksBySection structure:', risksBySection);

      // Ensure assessment exists with modelRisks structure
      const existingAssessment = state.byAssessment[assessmentUuid] || {};
      const existingModelRisks = existingAssessment.modelRisks || {};

      const updatedModel = {
        ...existingAssessment,
        modelRisks: {
          ...existingModelRisks,
          ...Object.keys(risksBySection).reduce((acc, section) => {
            acc[section] = {
              ...(existingModelRisks[section] || {}),
              areaRisks: {
                ...(existingModelRisks[section]?.areaRisks || {}),
                ...risksBySection[section].areaRisks,
              },
            };
            return acc;
          }, {}),
        },
      };

      console.log('Updated assessment state:', updatedModel.modelRisks);

      return {
        ...state,
        byAssessment: {
          ...state.byAssessment,
          [assessmentUuid]: updatedModel,
        },
      };
    }


    // LEGACY - inline action type never dispatched from components
    // case 'risks/updateActiveSections': {
    //   console.log('Received updateActiveSections action:', action);
    //   const { assessmentUuid, sections } = action.payload;
    //   return {
    //     ...state,
    //     byAssessment: {
    //       ...state.byAssessment,
    //       [assessmentUuid]: {
    //         ...state.byAssessment[assessmentUuid],
    //         activeSections: sections,
    //       },
    //     },
    //   };
    // }
        case SET_RISK_PRIORITY_START: {
          const { assessmentUuid, sectionName, category, riskId } = action.payload;
          return {
            ...state,
            byAssessment: {
              ...state.byAssessment,
              [assessmentUuid]: {
                ...state.byAssessment[assessmentUuid],
                modelRisks: {
                  ...state.byAssessment[assessmentUuid]?.modelRisks,
                  [sectionName]: {
                    ...state.byAssessment[assessmentUuid]?.modelRisks?.[sectionName],
                    areaRisks: {
                      ...state.byAssessment[assessmentUuid]?.modelRisks?.[sectionName]?.areaRisks,
                      [category]: state.byAssessment[assessmentUuid]?.modelRisks?.[sectionName]?.areaRisks?.[category]?.map(risk =>
                        risk.riskId === riskId ? { ...risk, loading: true } : risk
                      ) || []
                    }
                  }
                }
              }
            }
          };
        }

    case SET_RISK_PRIORITY_SUCCESS: {
      const { assessmentUuid, sectionName, category, riskId, priority, rationale } = action.payload;

      // Safe navigation - check if assessment exists and has required structure
      if (!state.byAssessment[assessmentUuid]?.modelRisks?.[sectionName]?.areaRisks?.[category]) {
        console.warn('[riskReducer] SET_RISK_PRIORITY_SUCCESS: Invalid state structure', { assessmentUuid, sectionName, category });
        return state;
      }

      return {
        ...state,
        byAssessment: {
          ...state.byAssessment,
          [assessmentUuid]: {
            ...state.byAssessment[assessmentUuid],
            modelRisks: {
              ...state.byAssessment[assessmentUuid].modelRisks,
              [sectionName]: {
                ...state.byAssessment[assessmentUuid].modelRisks[sectionName],
                areaRisks: {
                  ...state.byAssessment[assessmentUuid].modelRisks[sectionName].areaRisks,
                  [category]: state.byAssessment[assessmentUuid].modelRisks[sectionName].areaRisks[category]?.map(risk => {
                    if (risk.riskId !== riskId) return risk;
                    return {
                      ...risk,
                      loading: false,
                      priority: priority,
                      rationale: rationale
                    };
                  })
                }
              }
            }
          }
        }
      };
    }

    case SET_RISK_PRIORITY_FAILURE: {
      const { assessmentUuid, sectionName, category, riskId, error } = action.payload;
      return {
        ...state,
        byAssessment: {
          ...state.byAssessment,
          [assessmentUuid]: {
            ...state.byAssessment[assessmentUuid],
            modelRisks: {
              ...state.byAssessment[assessmentUuid].modelRisks,
              [sectionName]: {
                ...state.byAssessment[assessmentUuid].modelRisks[sectionName],
                areaRisks: {
                  ...state.byAssessment[assessmentUuid].modelRisks[sectionName].areaRisks,
                  [category]: state.byAssessment[assessmentUuid].modelRisks[sectionName].areaRisks[category]?.map(risk => {
                    if (risk.riskId !== riskId) return risk;
                    return {
                      ...risk,
                      loading: false,
                      error: error
                    };
                  })
                }
              }
            }
          }
        }
      };
    }

    case UPDATE_RISK_PRIORITY: {
      const { assessmentUuid, sectionName, category, riskId, priority } = action.payload;
      return {
        ...state,
        byAssessment: {
          ...state.byAssessment,
          [assessmentUuid]: {
            ...state.byAssessment[assessmentUuid],
            modelRisks: {
              ...state.byAssessment[assessmentUuid].modelRisks,
              [sectionName]: {
                ...state.byAssessment[assessmentUuid].modelRisks[sectionName],
                areaRisks: {
                  ...state.byAssessment[assessmentUuid].modelRisks[sectionName].areaRisks,
                  [category]: state.byAssessment[assessmentUuid].modelRisks[sectionName].areaRisks[category]?.map(risk => {
                    if (risk.riskId !== riskId) return risk;
                    return { ...risk, priority };
                  })
                }
              }
            }
          }
        }
      };
    }

    case DISCARD_RISKS: {
      const { assessmentUuid, sectionName, risk } = action.payload;
      const assessment = state.byAssessment[assessmentUuid];
      if (!assessment) {
        console.error("Assessment not found in state", assessmentUuid);
        return state;
      }

      // Guard against undefined modelRisks (RTK-first mode)
      const modelRisks = assessment.modelRisks || {};
      const section = modelRisks[sectionName] || {};
      const currentSectionRisks = section.areaRisks || {};

      const updatedSectionRisks = Object.keys(currentSectionRisks).reduce((acc, category) => {
        acc[category] = (currentSectionRisks[category] || []).map(r =>
          r.riskName === risk.riskName ? { ...r, status: 'Discarded' } : r
        );
        return acc;
      }, {});

      return {
        ...state,
        byAssessment: {
          ...state.byAssessment,
          [assessmentUuid]: {
            ...assessment,
            modelRisks: {
              ...modelRisks,
              [sectionName]: {
                ...section,
                areaRisks: updatedSectionRisks
              }
            }
          }
        }
      };
    }
    case DISCARD_UNSAVED_RISKS: {
      const { risksToDiscard, assessmentUuid } = action.payload;
      const assessment = state.byAssessment[assessmentUuid];

      if (!assessment) {
        console.error(`Assessment with ID ${assessmentUuid} not found.`);
        return state;
      }

      // Initialize discardedRisks array if it doesn't exist
      const existingDiscardedRisks = assessment.discardedRisks || [];

      // Filter out the risks to discard from their original sections
      const updatedRiskFormData = { ...assessment.modelRisks };
      risksToDiscard.forEach((risk) => {
        Object.keys(updatedRiskFormData).forEach((section) => {
          const categories = updatedRiskFormData[section].areaRisks;
          Object.keys(categories).forEach((category) => {
            const updatedRisks = categories[category].filter(
              (r) => r.riskName !== risk.riskName || r.status !== 'Draft'
            );
            updatedRiskFormData[section].areaRisks[category] = updatedRisks;
          });
        });
      });

      // Avoid duplicates in discardedRisks based on riskName
      const newDiscardedRisks = [
        ...existingDiscardedRisks,
        ...risksToDiscard.filter(
          (risk) => !existingDiscardedRisks.some((discarded) => discarded.riskName === risk.riskName)
        ),
      ];

      return {
        ...state,
        byAssessment: {
          ...state.byAssessment,
          [assessmentUuid]: {
            ...assessment,
            modelRisks: updatedRiskFormData,
            discardedRisks: newDiscardedRisks,
          },
        },
      };
    }
    case FETCH_RISKS_START: {
      const { assessmentUuid, sectionsToFetch } = action.payload;
      let newState = { ...state };

      if (!newState.byAssessment[assessmentUuid]) {
        console.error(`Assessment with ID ${assessmentUuid} not found.`);
      } else {
        if (!newState.byAssessment[assessmentUuid].sectionLoading) {
          newState.byAssessment[assessmentUuid].sectionLoading = {};
        }

        sectionsToFetch.forEach(section => {
          newState.byAssessment[assessmentUuid].sectionLoading[section] = true;
        });
      }

      return newState;
    }

    case FETCH_RISKS_FAILURE: {
      const { assessmentUuid, sectionsToFetch } = action.payload;
      let newState = { ...state };

      if (newState.byAssessment[assessmentUuid] && newState.byAssessment[assessmentUuid].sectionLoading) {
        sectionsToFetch.forEach(section => {
          newState.byAssessment[assessmentUuid].sectionLoading[section] = false;
        });
      } else {
        console.error(`Assessment with ID ${assessmentUuid} not found or sectionLoading not initialized.`);
      }

      return newState;
    }

    case FETCH_RISK_CARD_DATA_START: {
      const { assessmentUuid } = action.payload;
      return {
        ...state,
        byAssessment: {
          ...state.byAssessment,
          [assessmentUuid]: {
            ...state.byAssessment[assessmentUuid],
            loading: true,
          },
        },
      };
    }
  

 case FETCH_RISK_CARD_DATA_SUCCESS: {
      const { assessmentUuid, fetchedData } = action.payload;

      // Guard – ensure assessment exists
      if (!state.byAssessment[assessmentUuid]?.modelRisks) {
        console.error(`Assessment ID ${assessmentUuid} not found.`);
        return state;
      }

      // Work on a deep copy
      const updatedRiskFormData = _.cloneDeep(
        state.byAssessment[assessmentUuid].modelRisks
      );

      // Utility to coerce any value into a well‑formed array
      const toArray = (v) =>
        v == null ? [] : Array.isArray(v) ? v : [v];

      Object.entries(fetchedData).forEach(([riskArea, riskSources]) => {
        const area = updatedRiskFormData[riskArea];
        if (!area) return; // unknown section, skip

        // Prepare selectedSources collector for this area
        const selectedSet = new Set(area.selectedSources?.map(s => s.name));

        riskSources.forEach(({ name, value, causes, causesByValue, selected }) => {
          const src = area.riskSources.find((s) => s.name === name);
          if (!src) return; // skip sources not present in baseline config

          // Ensure each source has its own unique causesTemplate
          // Use the original template from baseline config (contains all categories)
          // Store it BEFORE we potentially overwrite src.causes with saved data
          const originalTemplate = _.cloneDeep(src.causes || {});
          src.causesTemplate = originalTemplate;
          
          console.log(`[FETCH_RISK_CARD_DATA_SUCCESS] Processing source: ${name}`, {
            hasOriginalTemplate: Object.keys(originalTemplate).length > 0,
            templateKeys: Object.keys(originalTemplate),
            hasSavedCauses: !!(causes && typeof causes === 'object'),
            savedCausesKeys: causes ? Object.keys(causes) : []
          });

          // ------------- top‑level value -------------
          src.value = toArray(value);
          // store per‑source‑value blobs so UI can address each option separately
          src.causesByValue = causesByValue || {};
          
          /* ---- Merge saved data into full template to preserve all categories ---- */
          if (causes && typeof causes === 'object') {
            // Start with full template, then merge in saved data with isolation
            src.causes = _.merge(_.cloneDeep(src.causesTemplate), _.cloneDeep(causes));
          } else {
            // If no causes from DB, use the full template
            src.causes = _.cloneDeep(src.causesTemplate);
          }
          
          // mark as selected in UI if the backend flagged it
          if (selected) selectedSet.add(name);
        });

        area.selectedSources = area.riskSources.filter(s => selectedSet.has(s.name));
      });

      return {
        ...state,
        byAssessment: {
          ...state.byAssessment,
          [assessmentUuid]: {
            ...state.byAssessment[assessmentUuid],
            modelRisks: updatedRiskFormData,
          },
        },
      };
    }
  

    case FETCH_RISK_CARD_DATA_FAILURE: {
      const { assessmentUuid, error } = action.payload;
      return {
        ...state,
        byAssessment: {
          ...state.byAssessment,
          [assessmentUuid]: {
            ...state.byAssessment[assessmentUuid],
            error: error,
            loading: false,
          },
        },
      };
    }

    case SET_STEP: {
      const { assessmentUuid, sectionName, stepName } = action.payload;
      console.log('payload in set_step reducer', action.payload);

      if (state.byAssessment[assessmentUuid]?.modelRisks?.[sectionName]) {
        return {
          ...state,
          byAssessment: {
            ...state.byAssessment,
            [assessmentUuid]: {
              ...state.byAssessment[assessmentUuid],
              modelRisks: {
                ...state.byAssessment[assessmentUuid].modelRisks,
                [sectionName]: {
                  ...state.byAssessment[assessmentUuid].modelRisks[sectionName],
                  currentStep: stepName  // Update the current step in the specific section
                }
              }
            }
          }
        };
      }

      console.warn(`Assessment with ID ${assessmentUuid} or section ${sectionName} not found.`);
      return state;
    }

    case UPDATE_ASSESSMENT_STEP_SUCCESS: {
      const { assessmentUuid, currentStep } = action.payload;
      if (state.byAssessment[assessmentUuid]) {
        return {
          ...state,
          byAssessment: {
            ...state.byAssessment,
            [assessmentUuid]: {
              ...state.byAssessment[assessmentUuid],
              step: currentStep,
            }
          }
        };
      }
      console.warn(`Assessment with ID ${assessmentUuid} not found.`);
      return state;
    }

    case UPDATE_ASSESSMENT_STEP_FAILURE: {
      const { assessmentUuid, error } = action.payload;
      if (state.byAssessment[assessmentUuid]) {
        return {
          ...state,
          byAssessment: {
            ...state.byAssessment,
            [assessmentUuid]: {
              ...state.byAssessment[assessmentUuid],
              error: error,
            },
          },
        };
      }
      console.warn(`Assessment with ID ${assessmentUuid} not found.`);
      return state;
    }

    case ASSESSMENT_STATUS_UPDATED: {
      const { assessmentUuid, assessmentStatus } = action.payload;
      console.log('assessment status received at reducer', action.payload);
      return {
        ...state,
        byAssessment: {
          ...state.byAssessment,
          [assessmentUuid]: {
            ...state.byAssessment[assessmentUuid],
            assessmentStatus: assessmentStatus
          }
        }
      };
    }

    case ASSESSMENT_STATUS_FAILED: {
      const { assessmentUuid, error } = action.payload;
      return {
        ...state,
        byAssessment: {
          ...state.byAssessment,
          [assessmentUuid]: {
            ...state.byAssessment[assessmentUuid],
            error: error
          }
        }
      };
    }

   // In src/redux/reducers/riskReducer.js, inside your switch(action.type):

   case REFINE_RISK_START: {
    const { assessmentUuid } = action.payload;
    return {
      ...state,
      byAssessment: {
        ...state.byAssessment,
        [assessmentUuid]: {
          ...state.byAssessment[assessmentUuid],
          loading: true
        }
      }
    };
  }

case REFINE_RISK_SUCCESS: {
  console.log('[riskReducer] REFINE_RISK_SUCCESS payload:', action.payload);
  const {
    assessmentUuid,
    sectionName,
    category,
    originalName,
    refinedRisk,
    rationale,
  } = action.payload;

  const modelState = state.byAssessment[assessmentUuid];
  if (!modelState) return state;

  const sectionData = modelState.modelRisks[sectionName];
  if (!sectionData) return state;

  // update just the one risk in that category
  const updatedSectionRisks = {
    ...sectionData.areaRisks,
    [category]: sectionData.areaRisks[category].map(risk =>
      risk.riskName === originalName
        ? { ...risk, refinedRisk, refineRationale: rationale }
        : risk
    )
  };

  return {
    ...state,
    byAssessment: {
      ...state.byAssessment,
      [assessmentUuid]: {
        ...state.byAssessment[assessmentUuid],
        modelRisks: {
          ...state.byAssessment[assessmentUuid].modelRisks,
          [sectionName]: {
            ...state.byAssessment[assessmentUuid].modelRisks[sectionName],
            areaRisks: updatedSectionRisks,
          }
        },
        loading: false
      }
    },
    refinedRiskDraft: { risk: refinedRisk, rationale }
  };
}

case REFINE_RISK_FAILURE: {
  const { assessmentUuid, error } = action.payload;
  return {
    ...state,
    byAssessment: {
      ...state.byAssessment,
      [assessmentUuid]: {
        ...state.byAssessment[assessmentUuid],
        loading: false,
        error
      }
    }
  };
}

    case UPDATE_RISK_NAME: {
      const { assessmentUuid, sectionName, originalName, newName } = action.payload;
      console.log('update risk in state payload:', action.payload);

      const currentSectionRisks = state.byAssessment[assessmentUuid]?.modelRisks?.[sectionName]?.areaRisks;
      if (!currentSectionRisks) {
        console.error(`Section risks not found for assessmentUuid: ${assessmentUuid}, sectionName: ${sectionName}`);
        return state;
      }

      const updatedSectionRisks = Object.keys(currentSectionRisks).reduce((acc, category) => {
        acc[category] = currentSectionRisks[category].map(risk =>
          risk.riskName === originalName ? { ...risk, riskName: newName } : risk
        );
        return acc;
      }, {});

      return {
        ...state,
        byAssessment: {
          ...state.byAssessment,
          [assessmentUuid]: {
            ...state.byAssessment[assessmentUuid],
            modelRisks: {
              ...state.byAssessment[assessmentUuid].modelRisks,
              [sectionName]: {
                ...state.byAssessment[assessmentUuid].modelRisks[sectionName],
                areaRisks: updatedSectionRisks
              }
            }
          }
        }
      };
    }

    case SET_RISK_EVALUATION: {
      const { assessmentUuid, riskId, themeId, evaluationData, sectionName, category } = action.payload;
      console.log('action payload in set_risk_eval reducer', action.payload);

      // 1) Check existence of the category array
      if (!state.byAssessment[assessmentUuid]?.modelRisks?.[sectionName]?.areaRisks?.[category]) {
        console.error(`Assessment with ID ${assessmentUuid} or category ${category} not found or areaRisks not initialized.`);
        return state;
      }

      // 2) Deep clone the byAssessment
      const updatedByAssessment = JSON.parse(JSON.stringify(state.byAssessment));

      // 3) Find the target risk within that category
      const areaRisks = updatedByAssessment[assessmentUuid].modelRisks[sectionName].areaRisks[category];
      const targetRisk = areaRisks.find(risk => risk.riskId === riskId);

      if (targetRisk) {
        if (!targetRisk.evaluationData) {
          // Initialize evaluationData if it doesn't exist
          targetRisk.evaluationData = {};
        }

        // 4) If there's no entry for this themeId, init it
        if (!targetRisk.evaluationData[themeId]) {
          targetRisk.evaluationData[themeId] = {};
        }

        // 5) Perform a deep merge of the incoming "evaluationData" into the existing data
        targetRisk.evaluationData[themeId] = _.merge(
          {},
          targetRisk.evaluationData[themeId], // existing data
          evaluationData                      // incoming data
        );


      } else {
        console.error(`Risk with ID ${riskId} not found in category ${category}.`);
      }

      // 6) Return updated state
      return {
        ...state,
        byAssessment: updatedByAssessment
      };
    }

    // LEGACY - action creator exists but never imported/called from components
    // case UPDATE_CONTROL_IN_SELECTED_RISK: {
    //   const { assessmentUuid, riskName, controlData } = action.payload;
    //   //console.log("Reducer Payload for selected controls: ", action.payload);
    //   return {
    //     ...state,
    //     byAssessment: {
    //       ...state.byAssessment,
    //       [assessmentUuid]: {
    //         ...state.byAssessment[assessmentUuid],
    //         savedRisks: state.byAssessment[assessmentUuid].savedRisks.map(risk => {
    //           if (risk.riskName === riskName) {
    //             return {
    //               ...risk,
    //               selectedControls: controlData
    //             };
    //           }
    //           return risk;
    //         })
    //       }
    //     }
    //   };
    // }

  

    case UPDATE_RISK_EVALUATION: {
      const {
        assessmentUuid,
        riskId,
        sectionName,
        themeId,
        attribute,  // e.g. "riskImpact" or "likelihood"
        property,   // e.g. "overallImpact", "duration", "probability", etc.
        value,
        priority,
        rationale,
        category,
      } = action.payload;
    
      console.log('received payload in updateRiskEvaluation reducer:', action.payload);
    
      // 1) Copy the array of risks under the specified category
      const existingRisks =
        state.byAssessment[assessmentUuid]?.modelRisks[sectionName]?.areaRisks?.[category] || [];
    
      // 2) Map over them, looking for the risk to update
      const updatedRisks = existingRisks.map((risk) => {
        if (risk.riskId !== riskId) {
          return risk; // not the correct risk
        }
    
        // 3) Copy or init evaluationData
        const evaluationData = { ...(risk.evaluationData || {}) };
        const themeEvaluation = { ...(evaluationData[themeId] || {}) };
    
        // 4) Within that theme, ensure we have an object for the attribute (e.g. "riskImpact")
        // e.g. themeEvaluation.riskImpact = { overallImpact: "Low", intensity: ... }
        if (!themeEvaluation[attribute]) {
          themeEvaluation[attribute] = {};
        }
    
        // 5) Set the property on that attribute object
        // e.g. themeEvaluation.riskImpact.overallImpact = "Moderate"
        themeEvaluation[attribute][property] = value;
    
        // Write it back
        evaluationData[themeId] = themeEvaluation;
    
        // 6) Optionally set priority, rationale
        return {
          ...risk,
          evaluationData,
          priority: priority ?? risk.priority,
          rationale: rationale ?? risk.rationale,
        };
      });
    
      // 7) Return the updated state
      return {
        ...state,
        byAssessment: {
          ...state.byAssessment,
          [assessmentUuid]: {
            ...state.byAssessment[assessmentUuid],
            modelRisks: {
              ...state.byAssessment[assessmentUuid].modelRisks,
              [sectionName]: {
                ...state.byAssessment[assessmentUuid].modelRisks[sectionName],
                areaRisks: {
                  ...state.byAssessment[assessmentUuid].modelRisks[sectionName].areaRisks,
                  [category]: updatedRisks,
                },
              },
            },
          },
        },
      };
    }


    case FETCH_RISK_EVALUATIONS: {
      const { assessmentUuid } = action.payload;
      return {
        ...state,
        byAssessment: {
          ...state.byAssessment,
          [assessmentUuid]: {
            ...state.byAssessment[assessmentUuid],
            loading: true,
            error: null,
          },
        },
      };
    }

// riskReducer.js (excerpt)

case FETCH_RISK_EVALUATIONS_SUCCESS: {
  const { assessmentUuid, evaluations, sectionName, riskEvaluationForm } = action.payload;
  const updatedByAssessment = { ...state.byAssessment };
  const assessment = updatedByAssessment[assessmentUuid];
  if (!assessment) return state;

  // Guard against undefined modelRisks (RTK-first mode)
  if (!assessment.modelRisks) return state;
  const section = assessment.modelRisks[sectionName];
  if (!section) return state;

  const updatedAreaRisks = { ...section.areaRisks };

  // For each category -> risk -> merge from the DB array
  Object.keys(updatedAreaRisks).forEach((catName) => {
    updatedAreaRisks[catName] = updatedAreaRisks[catName].map((risk) => {
      const newEvaluationData = { ...risk.evaluationData };
      // We'll match by (riskId, themeId)
      evaluations.forEach((dbEval) => {
        // Instead of checking `&& dbEval.theme_id === risk.themeId`
        // we only check if the riskId matches
        if (dbEval.risk_id === risk.riskId) {
          const themeId = dbEval.theme_id;
          newEvaluationData[themeId] = newEvaluationData[themeId] || {};

          // Use evaluation form from action payload (passed from action)
          const evaluationFormFromConfigs = riskEvaluationForm || [];
          console.log('[Reducer] FETCH_RISK_EVALUATIONS_SUCCESS mapping:', {
            themeId,
            dbEval,
            evaluationFormFromConfigs: evaluationFormFromConfigs.length,
            configFromPayload: !!riskEvaluationForm,
            configLength: riskEvaluationForm?.length
          });

          if (evaluationFormFromConfigs.length === 0) {
            // Error: Config should always be available via action payload
            console.error('[Reducer] riskEvaluationForm config not available in action payload. Cannot map evaluation data without config.');
            // Skip this evaluation instead of using hardcoded fallback
            return;
          } else {
            evaluationFormFromConfigs.forEach((criterion) => {
              const attr = criterion.attribute;
              if (!newEvaluationData[themeId][attr]) {
                newEvaluationData[themeId][attr] = {};
              }
              // baseEval
              const baseKey = criterion.baseEvaluation.name;
              newEvaluationData[themeId][attr][baseKey] = dbEval[baseKey] || '';
              // deepDive
              criterion.deepDive.forEach((field) => {
                newEvaluationData[themeId][attr][field.name] = dbEval[field.name] || '';
              });
            });
          }
        }
      });
      return { ...risk, evaluationData: newEvaluationData };
    });
  });

  updatedByAssessment[assessmentUuid].modelRisks[sectionName].areaRisks = updatedAreaRisks;
  return { ...state, byAssessment: updatedByAssessment };
}

    case FETCH_RISK_EVALUATIONS_FAILURE: {
      const { assessmentUuid, error } = action.payload;
      return {
        ...state,
        byAssessment: {
          ...state.byAssessment,
          [assessmentUuid]: {
            ...state.byAssessment[assessmentUuid],
            loading: false,
            error,
          },
        },
      };
    }

   

    case UPDATE_ACTIVE_SECTIONS_FROM_SAVED_RISKS: {
      const { assessmentUuid, uniqueSections } = action.payload;
      console.log('action payload in act sec reducer', action.payload);

      if (state.byAssessment[assessmentUuid]) {
        return {
          ...state,
          byAssessment: {
            ...state.byAssessment,
            [assessmentUuid]: {
              ...state.byAssessment[assessmentUuid],
              activeSections: uniqueSections,
            },
          },
        };
      }

      console.warn(`Assessment with ID ${assessmentUuid} not found.`);
      return state;
    }

    case MOVE_SCENARIO_TO_RISKS: {
      const { assessmentUuid, riskArea, sourceName, scenario, owner } = action.payload;
      const assessment = state.byAssessment[assessmentUuid];
      if (!assessment) return state;

      /* ensure we are working with initialised structures */
      /* Guard against undefined modelRisks (RTK-first mode) */
      const modelRisks = assessment.modelRisks || {};
      const area = modelRisks[riskArea] || {};
      const currentSectionRisks = area.areaRisks || {};

      /* always keep/assign a stable riskId */
      const riskId = scenario.scenarioId || uuidv4();

      /* build a fully‑fledged Risk object */
      const newRisk = {
        riskId,
        riskName : scenario.scenarioText || scenario.variantText || '',
        category : sourceName,
        status   : 'Saved',            // ← directly saved
        type     : 'Scenario',         // identify provenance
        rationale: scenario.rationale || '',
        owner    : owner || null,
      };

      /* append (deduping on riskId) */
      const updatedCategoryRisks = [
        ...(currentSectionRisks[sourceName] || []).filter(r => r.riskId !== riskId),
        newRisk
      ];

      const nextSectionRisks = {
        ...currentSectionRisks,
        [sourceName]: updatedCategoryRisks
      };

      return {
        ...state,
        byAssessment: {
          ...state.byAssessment,
          [assessmentUuid]: {
            ...assessment,
            modelRisks: {
              ...modelRisks,
              [riskArea]: {
                ...area,
                areaRisks: nextSectionRisks
              }
            }
          }
        }
      };
    }
    case MOVE_RISK_TO_SAVED: {
      const { assessmentUuid, sectionName, risk } = action.payload;
      const assessment = state.byAssessment[assessmentUuid];
      if (!assessment) return state;

      // Guard against undefined modelRisks (RTK-first mode)
      const modelRisks = assessment.modelRisks || {};
      const section = modelRisks[sectionName] || {};
      const areaRisks = section.areaRisks || {};
      const cat = risk.category;

      // 1) Add/update the saved item
      const savedList = [
        ...(areaRisks[cat] || []).filter(r => r.riskId),
        { ...risk, status: 'Saved' }
      ];
      // 2) Drop the old draft(s)
      return {
        ...state,
        byAssessment: {
          ...state.byAssessment,
          [assessmentUuid]: {
            ...assessment,
            modelRisks: {
              ...modelRisks,
              [sectionName]: {
                ...section,
                areaRisks: {
                  ...areaRisks,
                  [cat]: savedList
                }
              }
            }
          }
        }
      };
    }

    case UPDATE_SAVED_RISK: {
      const { assessmentUuid, sectionName, riskId, category, newDetails } = action.payload;
      console.log('props received in update saved risk', action.payload);
      if (!state.byAssessment[assessmentUuid] || !state.byAssessment[assessmentUuid].modelRisks?.[sectionName]) {
        console.error(`No assessment with ID ${assessmentUuid} or section ${sectionName} exists.`);
        return state;
      }

      const areaRisks = {
        ...state.byAssessment[assessmentUuid].modelRisks[sectionName].areaRisks,
      };

      if (!areaRisks[category]) {
        areaRisks[category] = [];
      }

      areaRisks[category] = areaRisks[category].map((risk) =>
        risk.riskId === riskId ? { ...risk, ...newDetails } : risk
      );

      return {
        ...state,
        byAssessment: {
          ...state.byAssessment,
          [assessmentUuid]: {
            ...state.byAssessment[assessmentUuid],
            modelRisks: {
              ...state.byAssessment[assessmentUuid].modelRisks,
              [sectionName]: {
                ...state.byAssessment[assessmentUuid].modelRisks[sectionName],
                areaRisks,
              },
            },
          },
        },
      };
    }

    case DISCARD_SAVED_RISK: {
      const { riskId, assessmentUuid, sectionName } = action.payload;
      const currentAssessment = state.byAssessment[assessmentUuid];
      if (!currentAssessment) {
        console.error(`Assessment with ID ${assessmentUuid} not found.`);
        return state;
      }

      const areaRisks = { ...currentAssessment.modelRisks?.[sectionName]?.areaRisks };

      Object.keys(areaRisks).forEach(category => {
        areaRisks[category] = areaRisks[category].map(risk =>
          risk.riskId === riskId ? { ...risk, status: 'Discarded' } : risk
        );
      });

      return {
        ...state,
        byAssessment: {
          ...state.byAssessment,
          [assessmentUuid]: {
            ...currentAssessment,
            modelRisks: {
              ...currentAssessment.modelRisks,
              [sectionName]: {
                ...currentAssessment.modelRisks[sectionName],
                areaRisks,
              }
            }
          }
        }
      };
    }

    case FETCH_SECTION_SPECIFIC_RISKS_START: {
      const { assessmentUuid, sectionName } = action.payload;
      return {
        ...state,
        byAssessment: {
          ...state.byAssessment,
          [assessmentUuid]: {
            ...state.byAssessment[assessmentUuid],
            sectionLoading: {
              ...state.byAssessment[assessmentUuid].sectionLoading,
              [sectionName]: true,
            },
          },
        },
      };
    }

   

    case FETCH_SECTION_SPECIFIC_RISKS_SUCCESS: {
      const { assessmentUuid, sectionName, risks } = action.payload;
      console.log('Draft risks to enter into state', risks);

      // Get the existing risks in this section
      const existingRisks = state.byAssessment[assessmentUuid]?.modelRisks[sectionName]?.areaRisks || {};

      // Process the new risks, merging them with existing risks
      const updatedRisks = Object.entries(risks).reduce((acc, [category, risksArray]) => {
        // Combine new risks with existing ones for each category
        acc[category] = [
          ...(existingRisks[category] || []).filter(risk => risk.status !== 'Generated'), // Preserve non-generated risks
          ...risksArray.map(risk => ({
            ...risk,
            status: risk.status || 'Generated', // Ensure each new risk has a 'Generated' status
            riskName: risk.riskName,
            category: risk.category,
            causes: risk.causes,
            type:risk.type, 
            rag_source_file: risk.rag_source_file || 'Unknown', // Assign sourceFile if available
          }))
        ];
        return acc;
      }, {});

      return {
        ...state,
        byAssessment: {
          ...state.byAssessment,
          [assessmentUuid]: {
            ...state.byAssessment[assessmentUuid],
            modelRisks: {
              ...state.byAssessment[assessmentUuid].modelRisks,
              [sectionName]: {
                ...state.byAssessment[assessmentUuid].modelRisks[sectionName],
                areaRisks: updatedRisks,
              },
            },
            sectionLoading: {
              ...state.byAssessment[assessmentUuid].sectionLoading,
              [sectionName]: false,
            },
          },
        },
      };
    }

    case FETCH_SECTION_SPECIFIC_RISKS_FAILURE: {
      const { assessmentUuid, sectionName, error } = action.payload;
      return {
        ...state,
        byAssessment: {
          ...state.byAssessment,
          [assessmentUuid]: {
            ...state.byAssessment[assessmentUuid],
            sectionLoading: {
              ...state.byAssessment[assessmentUuid].sectionLoading,
              [sectionName]: false,
            },
            error,
          },
        },
      };
    }

    case REFRESH_RISKS_SUCCESS: {
      const { assessmentUuid, sectionName, categorizedRisks } = action.payload;
      const existingRisks = state.byAssessment[assessmentUuid]?.modelRisks[sectionName]?.areaRisks || {};

      const updatedRisks = { ...existingRisks };

      Object.entries(categorizedRisks).forEach(([category, risksArray]) => {
        updatedRisks[category] = [
          ...(existingRisks[category] || []).filter(risk => risk.status !== 'Generated'), // Preserve non-generated risks
          ...risksArray.map(risk => ({
            ...risk,
            status: risk.status || 'Generated',
            riskName: risk.riskName,
          }))
        ];
      });

      return {
        ...state,
        byAssessment: {
          ...state.byAssessment,
          [assessmentUuid]: {
            ...state.byAssessment[assessmentUuid],
            modelRisks: {
              ...state.byAssessment[assessmentUuid].modelRisks,
              [sectionName]: {
                ...state.byAssessment[assessmentUuid].modelRisks[sectionName],
                areaRisks: updatedRisks,
              },
            },
            sectionLoading: {
              ...state.byAssessment[assessmentUuid].sectionLoading,
              [sectionName]: false,
            },
          },
        },
      };
    }

    case UPDATE_SECTION_PROGRESS: {
      const { assessmentUuid, sectionName, progress } = action.payload;
      return {
        ...state,
        byAssessment: {
          ...state.byAssessment,
          [assessmentUuid]: {
            ...state.byAssessment[assessmentUuid],
            modelRisks: {
              ...state.byAssessment[assessmentUuid].modelRisks,
              [sectionName]: {
                ...state.byAssessment[assessmentUuid].modelRisks[sectionName],
                assessmentProgress: progress,  // Store progress directly in the section
              },
            },
          },
        },
      };
    }
        /* ─────────────────────────────────────────────────────────────
       Source-level tracking for AssessmentStepperV2
       ───────────────────────────────────────────────────────────── */
       case REGISTER_RISK_SOURCES: {
        const { assessmentUuid, riskArea, names } = action.payload;
        const assessment = state.byAssessment[assessmentUuid];
        if (!assessment) return state;
  
        const area  = assessment.modelRisks?.[riskArea] || {};
        const fresh = names.map(n => ({ name:n, selected:false, progress:0 }));
  
        return {
          ...state,
          byAssessment: {
            ...state.byAssessment,
            [assessmentUuid]: {
              ...assessment,
              modelRisks: {
                ...assessment.modelRisks,
                [riskArea]: { ...area, riskSources: fresh }
              }
            }
          }
        };
      }
  
      case TOGGLE_RISK_SOURCE: {
        const { assessmentUuid, riskArea, srcName } = action.payload;
        const assessment = state.byAssessment[assessmentUuid];
        if (!assessment) return state;
  
        const area  = assessment.modelRisks?.[riskArea];
        if (!area || !Array.isArray(area.riskSources)) return state;
  
        const next = area.riskSources.map(s =>
          s.name === srcName ? { ...s, selected: !s.selected } : s);
  
        return {
          ...state,
          byAssessment: {
            ...state.byAssessment,
            [assessmentUuid]: {
              ...assessment,
              modelRisks: {
                ...assessment.modelRisks,
                [riskArea]: { ...area, riskSources: next }
              }
            }
          }
        };
      }
  
      case SET_RISK_SOURCE_PROGRESS: {
        const { assessmentUuid, riskArea, srcName, progress } = action.payload;
        const assessment = state.byAssessment[assessmentUuid];
        if (!assessment) return state;
  
        const area  = assessment.modelRisks?.[riskArea];
        if (!area || !Array.isArray(area.riskSources)) return state;
  
        const next = area.riskSources.map(s =>
          s.name === srcName ? { ...s, progress } : s);
  
        return {
          ...state,
          byAssessment: {
            ...state.byAssessment,
            [assessmentUuid]: {
              ...assessment,
              modelRisks: {
                ...assessment.modelRisks,
                [riskArea]: { ...area, riskSources: next }
              }
            }
          }
        };
      }

    case GENERATE_RISK_NARRATIVE_START: {
      const { assessmentUuid, riskId } = action.payload;
      return {
        ...state,
        byAssessment: {
          ...state.byAssessment,
          [assessmentUuid]: {
            ...state.byAssessment[assessmentUuid],
            riskNarratives: {
              ...state.byAssessment[assessmentUuid].riskNarratives,
              [riskId]: { loading: true, text: null, error: null }
            }
          }
        }
      };
    }
    case GENERATE_RISK_NARRATIVE_SUCCESS: {
      const { assessmentUuid, riskId, narrative } = action.payload;
      return {
        ...state,
        byAssessment: {
          ...state.byAssessment,
          [assessmentUuid]: {
            ...state.byAssessment[assessmentUuid],
            riskNarratives: {
              ...state.byAssessment[assessmentUuid].riskNarratives,
              [riskId]: { loading: false, text: narrative, error: null }
            }
          }
        }
      };
    }
    case GENERATE_RISK_NARRATIVE_FAILURE: {
      const { assessmentUuid, riskId, error } = action.payload;
      return {
        ...state,
        byAssessment: {
          ...state.byAssessment,
          [assessmentUuid]: {
            ...state.byAssessment[assessmentUuid],
            riskNarratives: {
              ...state.byAssessment[assessmentUuid].riskNarratives,
              [riskId]: { loading: false, text: null, error }
            }
          }
        }
      };
    }

    default:
      return state;
  }

}

export default riskReducer;
